import { render, staticRenderFns } from "./VatRateUpdate.vue?vue&type=template&id=378a4925&"
import script from "./VatRateUpdate.vue?vue&type=script&lang=ts&"
export * from "./VatRateUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports